import React from "react";
import styled from "styled-components";
import { theme } from "@ui/styles/theme";
import { useSliderRange } from "./hooks";

interface RangePickerProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	onChange: (value: number) => void;
	value: number;
	step: number;
	max: number;
	min: number;
	disabled?: boolean;
}

export const RangePicker: React.FC<RangePickerProps> = ({
	onChange,
	value,
	step,
	max,
	min,
	disabled,
	...htmlProps
}) => {
	const { ref, range } = useSliderRange(value);

	return (
		<Container {...htmlProps} range={range}>
			<input
				ref={ref}
				type="range"
				step={step}
				value={value}
				min={min}
				max={max}
				onChange={(e) => onChange(+e.target.value)}
				disabled={disabled}
			/>
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "range",
})<{ range: number }>`
	width: 100%;

	input[type="range"] {
		-webkit-appearance: none;
		margin-right: 15px;
		width: 100%;
		height: 3px;
		background: rgba(0, 0, 0, 1);
		border-radius: 5px;
		background-image: linear-gradient(${theme.colors.secondary}, ${theme.colors.secondary});
		${({ range }) => `background-size:${range}% 100%`};
		background-repeat: no-repeat;
		cursor: pointer;

		:disabled {
			pointer-events: none;
			background-color: ${({ theme }) => theme.colors.lightgray};
		}
	}

	input[type="range"]::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: ${theme.colors.secondary};
		cursor: grab;

		&:disabled {
			pointer-events: none;
			background-color: ${({ theme }) => theme.colors.lightgray};
		}
	}

	input[type="range"]::-moz-range-thumb {
		appearance: none;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: ${theme.colors.secondary};
		cursor: grab;
		border: none;

		&:disabled {
			pointer-events: none;
			background-color: ${({ theme }) => theme.colors.lightgray};
		}
	}
`;
